import React, {useState} from "react";
import {animated, useSpring} from "react-spring";

const Category = ({toggleModal, categoryElementInfo}) => {
    const [isHovered, setIsHovered] = useState(false);

    const categoryClickedHandler = (e, item) => {
        toggleModal(item);
    }
    const handleMouseOver = () => {
        setIsHovered(true)
    }
    const handleMouseLeave = () => {
        setIsHovered(false)
    }

    const scaleStyle = useSpring({
        transform: isHovered ? "scale(1.2)" : "scale(1)",
        config: {
            tension: 300,
            friction: 10
        }
    });

    let customClass = '' +
        'grid ' +
        'mx-2 ' +
        'text-center ' +
        'text-white ' +
        'text-xs ' +
        'min-w-fms-category-img-mobile-width ' +
        'max-w-fms-category-img-mobile-width ' +
        'md:min-w-fms-category-img-desktop-width ' +
        'md:max-w-fms-category-img-desktop-width ' +
        'h-fms-category-img-mobile-height ' +
        'md:h-fms-category-img-desktop-height ' +
        'bg-fms-category-item-background ' +
        'items-center ' +
        'justify-center ' +
        'rounded-fms-radius-base ' +
        'md:rounded-fms-radius-xl ' +
        'overflow-hidden'

    return (
        <animated.div
            onClick={(e) => categoryClickedHandler(e, categoryElementInfo)}
            onMouseOver={
                () => handleMouseOver()
            }
            onMouseLeave={
                () => handleMouseLeave()
            }
            style={scaleStyle}
            className={customClass}>
            <img
                src={categoryElementInfo && categoryElementInfo.icon ? categoryElementInfo.icon : require('../../resources/icons/icon.jpg')}
                alt={categoryElementInfo?.name}
                style={{borderRadius: categoryElementInfo && categoryElementInfo.icon ? '' : '100%'}}
                className='w-fms-category-icon-width h-fms-category-icon-height md:w-fms-category-icon-desktop-width md:h-fms-category-icon-desktop-height'/>
            {!isHovered && <p className=''>{categoryElementInfo?.text}</p>}
        </animated.div>
    )
}

export default Category;